<template>
  <section id="tech-stack" class="tech-stack">
    <div class="container">
      <h2 v-scroll-reveal>{{ $t('techStack.title') }}</h2>
      <div class="tech-icons">
        <div class="tech-icon" v-for="tech in techs" :key="tech.name">
          <img :src="tech.icon" :alt="tech.alt" />
          <span>{{ tech.name }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import pythonIcon from '@/assets/tech/python.svg'
import awsIcon from '@/assets/tech/aws.svg'
import gcpIcon from '@/assets/tech/gcp.svg'
import dbtIcon from '@/assets/tech/dbt-icon.svg'
import kubeflowIcon from '@/assets/tech/kubeflow-icon.svg'
import pydanticIcon from '@/assets/tech/pydantic.png'
import langfuseIcon from '@/assets/tech/langfuse-color.svg'
import databricksIcon from '@/assets/tech/databricks.svg'

const techs = [
  { name: 'Python', icon: pythonIcon, alt: 'Python programming language logo — used for data engineering and AI development' },
  { name: 'AWS', icon: awsIcon, alt: 'Amazon Web Services (AWS) logo — cloud infrastructure for scalable data pipelines' },
  { name: 'GCP', icon: gcpIcon, alt: 'Google Cloud Platform (GCP) logo — cloud services for machine learning and data processing' },
  { name: 'dbt', icon: dbtIcon, alt: 'dbt (data build tool) logo — SQL-based data transformation framework' },
  { name: 'Kubeflow', icon: kubeflowIcon, alt: 'Kubeflow logo — Kubernetes-native ML pipeline orchestration platform' },
  { name: 'PydanticAI', icon: pydanticIcon, alt: 'PydanticAI logo — type-safe AI agent framework for building agentic applications' },
  { name: 'Langfuse', icon: langfuseIcon, alt: 'Langfuse logo — open-source LLM observability and monitoring platform for LLM Ops' },
  { name: 'Databricks', icon: databricksIcon, alt: 'Databricks logo — unified analytics platform for data engineering and AI workloads' },
]
</script>

<style scoped>
.tech-stack {
  padding: 60px 0;
  background-color: var(--gray-light);
}

.tech-stack h2 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 1.8rem;
}

.tech-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  align-items: center;
}

.tech-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  opacity: 0.7;
}

.tech-icon img {
  width: 60px;
  height: 60px;
  filter: grayscale(100%);
  transition: filter 0.3s, opacity 0.3s;
}

.tech-icon span {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-color);
}

.tech-icon:hover img {
  filter: grayscale(0%);
}

.tech-icon:hover {
  opacity: 1;
}
</style>
